<template>
  <header class="topnavbar-wrapper">
    <!-- START Top Navbar-->
    <nav class="navbar topnavbar">
      <!-- START navbar header-->
      <div class="navbar-header">
        <a class="navbar-brand" href="https://www.extractalpha.com">
          <div class="brand-logo">
            <img class="img-fluid" src="/custom/img/logo.png" alt="App Logo" />
          </div>
          <div class="brand-logo-collapsed">
            <img
              class="img-fluid"
              src="/custom/img/logo-single.png"
              alt="App Logo"
            />
          </div>
        </a>
      </div>
      <!-- END navbar header-->

      <!-- START Left navbar-->
      <ul class="navbar-nav left-nav flex-row">
        <li class="nav-item">
          <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
          <a
            href=""
            class="nav-link d-none d-md-block d-lg-block d-xl-block"
            @click.prevent="toggleAsideCollapsed"
          >
            <em class="fas fa-bars"></em>
          </a>
          <!-- Button to show/hide the sidebar on mobile. Visible on mobile only.-->
          <a
            href=""
            class="nav-link sidebar-toggle d-md-none"
            @click.prevent="toggleOffcanvas"
          >
            <em class="fas fa-bars"></em>
          </a>
        </li>
        <!-- START User avatar toggle-->
        <li class="nav-item d-none d-md-block">
          <!-- Button used to collapse the left sidebar. Only visible on tablet and desktops-->
          <a class="nav-link" href="" @click.prevent="toggleUserBlock">
            <em class="icon-user"></em>
          </a>
        </li>
        <!-- END User avatar toggle-->
        <!-- START lock screen-->
        <!-- <li class="nav-item d-none d-md-block">
                    <router-link class="nav-link" to="/lock" title="Lock screen">
                        <em class="icon-lock"></em>
                    </router-link>
                </li> -->
        <!-- END lock screen-->
      </ul>
      <!-- END Left navbar-->

      <!-- START Main Navbar -->
      <ul class="navbar-nav main-nav mr-auto flex-row">
        <li class="nav-item">
          <router-link class="nav-link" to="/landing"
            >AlphaClub Home</router-link
          >
        </li>
        <li class="nav-item">
          <router-link class="nav-link" to="/tearsheets"
          >Tearsheets</router-link
          >
        </li>
      </ul>
      <!-- END Main Navbar -->

      <!-- START Right Navbar-->
      <ul class="navbar-nav flex-row">
        <!-- Search icon-->
        <li class="nav-item">
          <a class="nav-link" href="#" data-search-open="">
            <em class="icon-magnifier"></em>
          </a>
        </li>
        <!-- Fullscreen (only desktops)-->
        <li class="nav-item d-none d-md-block">
          <ToggleFullscreen tag="A" class="nav-link" href="#" />
        </li>
        <!-- START Alert menu-->
        <!-- END Alert menu-->
        <!-- START Offsidebar button-->
        <!-- END Offsidebar.prevent menu-->
      </ul>
      <!-- END Right Navbar-->
      <HeaderSearch />
    </nav>
    <!-- END Top Navbar-->
  </header>
</template>

<script>
import { mapMutations } from "vuex";
import HeaderSearch from "@/components/angle/Layout/HeaderSearch.vue";
import ToggleFullscreen from "@/components/angle/Common/ToggleFullscreen.vue";

export default {
  name: "Header",
  components: {
    HeaderSearch,
    ToggleFullscreen,
  },
  methods: {
    /**
     * Triggers a window resize event when clicked
     * for plugins that needs to be redrawed
     */
    resize: () => {
      // all IE friendly dispatchEvent
      var evt = document.createEvent("UIEvents");
      evt.initUIEvent("resize", true, false, window, 0);
      window.dispatchEvent(evt);
      // modern dispatchEvent way
      // window.dispatchEvent(new Event('resize'));
    },
    ...mapMutations(["toggleSetting"]),
    toggleOffsidebar() {
      this.toggleSetting("offsidebarOpen");
    },
    toggleOffcanvas() {
      this.toggleSetting("asideToggled");
    },
    toggleAsideCollapsed() {
      this.toggleSetting("isCollapsed");
      this.resize();
    },
    toggleUserBlock() {
      this.toggleSetting("showUserBlock");
    },
  },
};
</script>